import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppCategoryEditComponent } from '../components/edit/upp-edit';
import { UppCategoryViewComponent } from '../components/view/upp-view';
import { UppOptionEditComponent } from '../components/option/edit/upp-edit';
import { UppCategoryBriefComponent } from '../components/brief/upp-brief';
import { UppOptionViewComponent } from '../components/option/view/upp-view';

@NgModule({
    declarations: [
        UppCategoryEditComponent,
        UppCategoryViewComponent,
        UppOptionEditComponent,
        UppCategoryBriefComponent,
        UppOptionViewComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        DragDropModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule   
    ],
    exports: [
        UppCategoryEditComponent,
        UppCategoryViewComponent,
        UppCategoryBriefComponent
    ],
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]     
})
export class FeatureCategoryModule {}
